/* NORD cart drawer — JS estático (zero Liquid). Mesmo motivo: ~14KB por página. */
(function () {
    if (window.__nordCartDrawer) return;
    window.__nordCartDrawer = true;

    var LOCK_CLASS = 'nord-cart-locked';
    var SOURCE = 'nord-cart-drawer';
    var FOCUSABLE =
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function rootUrl() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return root.charAt(root.length - 1) === '/' ? root : root + '/';
    }

    function focusSafely(node) {
      if (!node) return;
      try {
        node.focus({ preventScroll: true });
      } catch (error) {
        node.focus();
      }
    }

    if (!customElements.get('nord-cart-drawer')) {
      customElements.define(
        'nord-cart-drawer',
        class NordCartDrawer extends HTMLElement {
          connectedCallback() {
            this.panel = this.querySelector('[data-nord-cart-panel]');
            this.sectionId = this.getAttribute('data-section-id');
            this.lastCount = this.readCount();
            this.returnFocus = null;
            this.noteTimer = null;
            this.previousPadding = '';
            /* Render sequencing: every request that may repaint the panel takes
               a ticket; only the LATEST ticket is allowed to apply its HTML.
               Without this, two in-flight refreshes can resolve out of order and
               a stale cart (e.g. pre-gift) wipes out the fresh one on screen. */
            this.renderSeq = 0;

            this.onClick = this.onClick.bind(this);
            this.onChange = this.onChange.bind(this);
            this.onInput = this.onInput.bind(this);
            this.onKeydown = this.onKeydown.bind(this);
            this.onDocumentClick = this.onDocumentClick.bind(this);
            this.onCartEvent = this.onCartEvent.bind(this);

            this.addEventListener('click', this.onClick);
            this.addEventListener('change', this.onChange);
            this.addEventListener('input', this.onInput);
            document.addEventListener('keydown', this.onKeydown);
            document.addEventListener('click', this.onDocumentClick);
            document.addEventListener('cart:refresh', this.onCartEvent);
            document.addEventListener('cart:update', this.onCartEvent);
          }

          disconnectedCallback() {
            document.removeEventListener('keydown', this.onKeydown);
            document.removeEventListener('click', this.onDocumentClick);
            document.removeEventListener('cart:refresh', this.onCartEvent);
            document.removeEventListener('cart:update', this.onCartEvent);
            this.unlock();
          }

          /* -------------------------------------------------------- state */
          get isOpen() {
            return this.getAttribute('data-open') === 'true';
          }

          readCount() {
            var heading = this.querySelector('[data-nord-cart-heading]');
            if (!heading) return 0;
            var match = heading.textContent.match(/\((\d+)\)/);
            return match ? parseInt(match[1], 10) : 0;
          }

          open() {
            if (this.isOpen) return;
            this.returnFocus = document.activeElement;
            this.setAttribute('data-open', 'true');
            this.lock();
            var target = this.querySelector('.nord-cart__close') || this.querySelector(FOCUSABLE);
            // Focus on the next frame so the slide-in is not interrupted.
            requestAnimationFrame(function () {
              focusSafely(target);
            });
          }

          close() {
            if (!this.isOpen) return;
            this.setAttribute('data-open', 'false');
            this.unlock();
            var previous = this.returnFocus;
            this.returnFocus = null;
            if (previous && typeof previous.focus === 'function' && document.contains(previous)) {
              focusSafely(previous);
            }
          }

          lock() {
            document.documentElement.classList.add(LOCK_CLASS);
          }

          unlock() {
            document.documentElement.classList.remove(LOCK_CLASS);
          }

          /* -------------------------------------------------- interaction */
          onClick(event) {
            if (event.target.closest('[data-nord-cart-dismiss]')) {
              event.preventDefault();
              this.close();
              return;
            }
            var step = event.target.closest('[data-nord-qty-step]');
            if (step) {
              event.preventDefault();
              this.changeLine(step, parseInt(step.getAttribute('data-nord-qty-step'), 10));
            }
          }

          onChange(event) {
            var input = event.target.closest('[data-nord-qty-input]');
            if (!input) return;
            var value = parseInt(input.value, 10);
            if (isNaN(value) || value < 0) value = 0;
            this.changeLine(input, value);
          }

          onInput(event) {
            var note = event.target.closest('[data-nord-cart-note]');
            if (!note) return;
            var value = note.value;
            clearTimeout(this.noteTimer);
            this.noteTimer = setTimeout(function () {
              fetch(rootUrl() + 'cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ note: value }),
              }).catch(function () {});
            }, 600);
          }

          onKeydown(event) {
            if (!this.isOpen) return;
            if (event.key === 'Escape' || event.key === 'Esc') {
              event.preventDefault();
              this.close();
              return;
            }
            if (event.key === 'Tab') this.trapFocus(event);
          }

          trapFocus(event) {
            if (!this.panel) return;
            var nodes = Array.prototype.filter.call(
              this.panel.querySelectorAll(FOCUSABLE),
              function (el) {
                return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
              }
            );
            if (!nodes.length) return;

            var first = nodes[0];
            var last = nodes[nodes.length - 1];

            if (!this.panel.contains(document.activeElement)) {
              event.preventDefault();
              first.focus();
              return;
            }
            if (event.shiftKey && document.activeElement === first) {
              event.preventDefault();
              last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
              event.preventDefault();
              first.focus();
            }
          }

          /* Any link to the cart route opens the drawer instead of navigating. */
          onDocumentClick(event) {
            if (event.defaultPrevented || event.button !== 0) return;
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

            var link = event.target.closest('a[href]');
            if (!link || this.contains(link)) return;
            if (link.hasAttribute('target') || link.hasAttribute('download')) return;
            if (link.hasAttribute('data-nord-no-drawer')) return;

            var cartPath = (this.getAttribute('data-cart-url') || '/cart').replace(/\/+$/, '');
            var href = link.getAttribute('href').split('?')[0].split('#')[0].replace(/\/+$/, '');
            if (href !== cartPath) return;

            event.preventDefault();
            // Open straight away — the 150ms panel delay covers the refresh.
            this.open();
            this.refresh();
          }

          /* ------------------------------------------------- cart mutation */
          changeLine(node, quantity) {
            var row = node.closest('[data-nord-line-key]');
            if (!row) return;
            var key = row.getAttribute('data-nord-line-key');
            var focusKey = node.getAttribute('data-nord-focus-key');
            var error = row.querySelector('[data-nord-line-error]');
            if (error) error.textContent = '';
            row.classList.add('is-busy');

            var self = this;
            var seq = ++this.renderSeq;

            /* Gift sync without flicker: when a trigger watch changes, the free
               box line is re-quantified in a chained second write BEFORE any
               paint — only the final response carries the sections payload, so
               the drawer repaints exactly once, already consistent, and
               gift-with-purchase has nothing left to fix. (cart/change.js is
               used for both writes; cart/update.js only takes variant ids, and
               feeding it line keys splits property-carrying lines.) */
            var giftRow = this.querySelector('.nord-cart__item--gift[data-nord-line-key]');
            var giftKey = giftRow ? giftRow.getAttribute('data-nord-line-key') : null;
            var withGift = row.hasAttribute('data-nord-trigger') && giftKey && giftKey !== key;

            var changePost = function (payload) {
              return fetch(rootUrl() + 'cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify(payload),
              });
            };

            var finalBody = {
              id: key,
              quantity: quantity,
              sections: this.sectionId,
              sections_url: window.location.pathname,
            };

            var request;
            if (withGift) {
              var desired = 0;
              var counted = {};
              this.querySelectorAll('[data-nord-trigger][data-nord-line-key]').forEach(function (line) {
                var lineKey = line.getAttribute('data-nord-line-key');
                if (counted[lineKey]) return;
                counted[lineKey] = true;
                if (lineKey === key) {
                  desired += quantity;
                } else {
                  var input = line.querySelector('[data-nord-qty-input]');
                  desired += input ? parseInt(input.value, 10) || 0 : 0;
                }
              });
              request = changePost({ id: key, quantity: quantity }).then(function (response) {
                if (!response.ok) return response;
                return changePost({
                  id: giftKey,
                  quantity: desired,
                  sections: self.sectionId,
                  sections_url: window.location.pathname,
                });
              });
            } else {
              request = changePost(finalBody);
            }

            request
              .then(function (response) {
                return response
                  .json()
                  .catch(function () {
                    return {};
                  })
                  .then(function (body) {
                    return { ok: response.ok, body: body };
                  });
              })
              .then(function (result) {
                if (!result.ok) {
                  row.classList.remove('is-busy');
                  if (error) {
                    error.textContent =
                      result.body.description || result.body.message || 'Could not update this item.';
                  }
                  return;
                }

                var html = result.body.sections && result.body.sections[self.sectionId];
                if (html) {
                  if (seq === self.renderSeq) self.applyHtml(html, focusKey);
                  if (typeof result.body.item_count === 'number') self.lastCount = result.body.item_count;
                  self.emit(result.body);
                  return;
                }
                // No section payload (static sections are not always addressable) —
                // fall back to a full refresh.
                self.refresh(focusKey).then(function (cart) {
                  self.emit(cart || result.body);
                });
              })
              .catch(function () {
                row.classList.remove('is-busy');
                if (error) error.textContent = 'Could not update this item.';
              });
          }

          /* Fresh markup for this section: prefer the Section Rendering API, fall
             back to scraping the current page if a static section is not addressable. */
          fetchHtml() {
            var self = this;
            var path = window.location.pathname;
            return fetch(path + '?sections=' + encodeURIComponent(this.sectionId), {
              headers: { Accept: 'application/json' },
            })
              .then(function (response) {
                return response.ok ? response.json() : null;
              })
              .then(function (payload) {
                var html = payload && payload[self.sectionId];
                if (html) return html;
                return fetch(path, { headers: { Accept: 'text/html' } }).then(function (response) {
                  return response.ok ? response.text() : null;
                });
              })
              .catch(function () {
                return null;
              });
          }

          refresh(focusKey) {
            var self = this;
            var seq = ++this.renderSeq;
            return Promise.all([
              fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } })
                .then(function (response) {
                  return response.ok ? response.json() : null;
                })
                .catch(function () {
                  return null;
                }),
              this.fetchHtml(),
            ]).then(function (results) {
              var cart = results[0];
              if (results[1] && seq === self.renderSeq) self.applyHtml(results[1], focusKey);
              if (cart && typeof cart.item_count === 'number') self.lastCount = cart.item_count;
              return cart;
            });
          }

          applyHtml(html, focusKey) {
            if (!html || !this.panel) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-nord-cart-panel]');
            if (!fresh) return;

            this.panel.innerHTML = fresh.innerHTML;

            if (!focusKey || !this.isOpen) return;
            var target =
              this.panel.querySelector('[data-nord-focus-key="' + focusKey + '"]') ||
              this.panel.querySelector('.nord-cart__close');
            focusSafely(target);
          }

          emit(cart) {
            document.dispatchEvent(
              new CustomEvent('cart:refresh', { detail: { cart: cart, source: SOURCE } })
            );
          }

          /* ------------------------------- inbound cart:refresh / cart:update */
          onCartEvent(event) {
            var detail = (event && event.detail) || {};
            if (detail.source === SOURCE) return;

            var previous = this.lastCount;
            var self = this;
            this.refresh().then(function (cart) {
              if (detail.open === false) return;
              var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
              if (detail.open === true || (count !== null && count > previous)) self.open();
            });
          }
        }
      );
    }

    /* --------------------------------------------------------------- bridge
       Satisfies the object nord-main-product.liquid looks for, so an AJAX
       add-to-cart opens this drawer instead of navigating to /cart. */
    if (!customElements.get('cart-notification')) {
      customElements.define(
        'cart-notification',
        class NordCartBridge extends HTMLElement {
          get drawer() {
            return document.querySelector('nord-cart-drawer');
          }

          getSectionsToRender() {
            var drawer = this.drawer;
            return drawer ? [{ id: drawer.getAttribute('data-section-id') }] : [];
          }

          setActiveElement(element) {
            this.activeElement = element;
          }

          renderContents(response) {
            var drawer = this.drawer;
            if (!drawer) {
              window.location = rootUrl() + 'cart';
              return;
            }

            drawer.open();
            var id = drawer.getAttribute('data-section-id');
            var html = response && response.sections && response.sections[id];

            if (html) {
              /* The add response already carries the final drawer markup
                 (watch + gift added in one request). Take a ticket so any
                 slower in-flight refresh cannot overwrite this paint, and
                 fetch only cart.js for the header count — a second HTML
                 round-trip here was pure latency and a race window. */
              drawer.renderSeq += 1;
              drawer.applyHtml(html);
              fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } })
                .then(function (r) { return r.ok ? r.json() : null; })
                .then(function (cart) {
                  if (cart && typeof cart.item_count === 'number') drawer.lastCount = cart.item_count;
                  drawer.emit(cart);
                })
                .catch(function () {});
              return;
            }

            drawer.refresh().then(function (cart) {
              drawer.emit(cart);
            });
          }
        }
      );
    }
  })();
